'use strict';
var ajax = require('./ajax'),
util = require('./util');

/**
 * Lazy Loading setup
 * If lazy images or asset elements are in the DOM, adds an intersection observer which loads these elements lazily on the page
 */
function initLazyLoading(container) {
    container = container ? container : document;
	//Check for lazy images, content assets filtering by container if set
    var lazyElements = $(container).find('.lazyImg, .lazyAsset');
    //if we have any lazy elements, setup the observer and lazy loading
    if (!lazyElements.length) {
        return;
    }
    //Lazy loading configuration
    var lzyConfig = {
        rootMargin:'100px 0px', //The margins that are added to the viewport to trigger lazy loading(e.g. 100px means an additional 100px below the viewport so should trigger lazy load earlier)
        threshold: 0.01 //How much of the image should be visible before triggering the load
    };

    var isInternetExplorer = false;
    // Internet Explorer does not support IntersectionObserver.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(trident)\/(\d+)/)) {
        isInternetExplorer = true;
    }

    //Setup the Observer Object
    if (isInternetExplorer) {
        for (var i = 0; i < lazyElements.length; i++) {
            var lazyElement = lazyElements[i]; //get the element node
            processNode(lazyElement);
        }
        return;
    }
    var lzyElementsObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) { //if this element is becoming visible, process it
                var lazyElement = entry.target; //get the element node
                processNode(lazyElement);
                lzyElementsObserver.unobserve(lazyElement); //Remove this element from the Observer
            }
        });
    }, lzyConfig);

    lazyElements.each(function () {
        lzyElementsObserver.observe(this);
    });
}

/**
 * Switches the lazy image to be the live image
 */
function switchLazyImage(node) {
    //Make sure we have data attributes set and they are different from the active values
    if (node.dataset.srcset && node.dataset.srcset !== node.srcset) { //switch the srcset attribute with data-srcset attribute
        node.srcset = node.dataset.srcset; //switch the srcset attribute with the data-srset attribute
    }
     //Make sure we have data attributes set and they are different from the active values
    if (node.dataset.src && node.dataset.src !== node.src) { //switch the src attribute with data-src attribute
        node.src = node.dataset.src; //switch the src attribute with the data-srset attribute
    }
}

/**
 * Processes the node and removes lazy class
 */
function processNode(lazyElement) {
    switch (lazyElement.nodeName) {
        case 'IMG':
            switchLazyImage(lazyElement);
            lazyElement.classList.remove('lazyImg');
            break;
        case 'PICTURE':
            var children = lazyElement.children;
            if (children.length) {
                for (var i = 0; i < children.length; i++) {
                    switchLazyImage(children[i]);
                }
            }
            lazyElement.classList.remove('lazyImg');
            break;
        case 'DIV':
            if (lazyElement.classList.contains('lazyAsset')) {
                var contentID = lazyElement.getAttribute('data-content-id');
                if (contentID) {
                    ajax.load({
                        url: util.appendParamsToUrl(Urls.includeContentAsset, {cid: contentID}),
                        callback: function (response) {
                            var contentAsset = $(response);
                            $(lazyElement).replaceWith(contentAsset);
                            // If the asset is in menu, trigger jQuery custom event to handle the subcategory display
                            var categoryMenu = contentAsset.closest('.top-level');
                            if (categoryMenu.length && categoryMenu.find('.sub-level').length) {
                                categoryMenu.trigger('lazyLoadComplete', { contentID: contentID });
                            }
                        }
                    });
                }
                lazyElement.classList.remove('lazyAsset');
            }
            break;
        default:
            break;
    }
}

exports.init = function (container) {
    initLazyLoading(container);
};
